import type { IntegrationRoutes } from '@tempo-io/integration-app/rpc';
import { hc } from 'hono/client';
import type { KyInstance } from 'ky';

export const getIntegrationServiceApi = ({
  prefixUrl = '',
  client,
}: {
  prefixUrl?: string;
  client: KyInstance;
}) =>
  hc<IntegrationRoutes>('/api/integrations/', {
    fetch: (input: RequestInfo | URL, requestInit?: RequestInit) => {
      return client(`${prefixUrl}${input}`, {
        method: requestInit?.method,
        headers: {
          'content-type': 'application/json',
          ...requestInit?.headers,
        },
        body: requestInit?.body,
      });
    },
  });
